import { createFileRoute } from "@tanstack/react-router";
import SuddenDepression from "@/pages/SuddenDepression";
export const Route = createFileRoute("/sudden-depression")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "Sudden Depression | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "Sudden depression can feel alarming. Learn about causes, when to seek help, and treatment options like TMS in Coral Springs, FL Free consultation available.",
        },
        {
          property: "og:title",
          content: "Sudden Depression | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "Sudden depression can feel alarming. Learn about causes, when to seek help, and treatment options like TMS in Coral Springs, FL Free consultation available.",
        },
        {
          property: "og:url",
          content: "https://neurowellnesstms.com/sudden-depression",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/sudden-depression",
        },
      ],
    };
  },
});
function RouteComponent() {
  return <SuddenDepression />;
}
